import { Image, View } from 'react-native';
import THEME from '../../../config/theme';
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { hexToRgba } from '../../../utils/colorUtils';
import { useCustomImages } from '../../../api/Brand';
import LogoMain from '../../../../assets/LogoMain.png';
import defaultUserPhoto from '../../../../assets/user.png';

/**
 * Avatar único de comentário, resposta e campo de escrever.
 *
 * Três estados, sempre no MESMO círculo — antes cada um tinha uma forma
 * diferente e a coluna ficava desalinhada:
 * - com foto: a foto do aluno, recortada em `cover`
 * - sem foto: `assets/user.png`, no lugar do ícone `Feather name="user"`, que
 *   era um glifo solto sem círculo e de tamanho variável
 * - admin: a logo da marca em `contain`, com respiro interno, para caber no
 *   círculo sem esticar (antes era 1.8rem retangular, destoando da lista)
 *
 * O `backgroundColor` derivado da cor de texto da marca fica por baixo de
 * propósito: é ele que segura o lugar enquanto a imagem decodifica, evitando o
 * buraco branco que aparecia a cada render.
 */
const CommentAvatar = ({ size = 36, photo, isAdmin = false, label }) => {
  const { customColor } = useCustomTheme();
  const { data: logo } = useCustomImages('logoApp');

  const textColor = customColor?.text?.app || THEME.COLORS.TEXT_MAIN;
  const surface = hexToRgba(textColor, 0.05) || '#F3F4F6';
  const border = hexToRgba(textColor, 0.12) || '#E5E7EB';

  const source = isAdmin
    ? logo?.url
      ? { uri: logo.url }
      : LogoMain
    : photo
      ? { uri: photo }
      : defaultUserPhoto;

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: surface,
        borderWidth: 1,
        borderColor: border,
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
        // Sem isto o avatar encolhe quando o nome do aluno é comprido.
        flexShrink: 0,
      }}
    >
      <Image
        source={source}
        resizeMode={isAdmin ? 'contain' : 'cover'}
        accessibilityLabel={label}
        style={
          isAdmin
            ? { width: size - 8, height: size - 8 }
            : { width: size, height: size }
        }
      />
    </View>
  );
};

export default CommentAvatar;
